export const GiddyUpModalCloseTopic = 'giddy-up.modal.close'
